import { CheckoutState } from '../../../../../Checkout/store/reducers';
import { CheckinState } from '../../../../../Modules/Checkin/store/reducers';

import { createCardExtraSelectors } from '../lib/createCardExtraSelectors';
import { CheckinOrderFragment, CheckoutOrderFragment } from '@websky/graphql';

export const checkoutCardExtraSelectors = createCardExtraSelectors<CheckoutState>(state => state.order);

export const checkinCardExtraSelectors = createCardExtraSelectors<CheckinState>(state => state.order);

export const createExtraServicesSelectors = <T = CheckoutOrderFragment | CheckinOrderFragment>(
	getOrderState: (state: T) => any
) => {};
